import React from "react";
import { ng } from "@common/ngds";
import { useProject } from "../features/projects/projectSlice";
import { SXInputSteelFireSettings } from "./FireSettings/SteelFireSettings";
import { SXInputConcreteFireSettings } from "./FireSettings/ConcreteFireSettings";
import { SXInputTimberFireSettings } from "./FireSettings/TimberFireSettings";

export const SXInputFireSettings: React.FC = () => {
  const { getProjectSectionObj } = useProject();
  const section = getProjectSectionObj();
  const rawCategory = (section as any)?.materialCategory;
  const materialCategory =
    rawCategory != null
      ? ng.sections.MaterialCategory_FromObject(rawCategory)
      : ng.sections.MaterialCategory.MATERIAL_CATEGORY_UNSPECIFIED;

  if (materialCategory === ng.sections.MaterialCategory.MATERIAL_CATEGORY_STEEL) {
    return <SXInputSteelFireSettings />;
  }

  if (materialCategory === ng.sections.MaterialCategory.MATERIAL_CATEGORY_TIMBER) {
    return <SXInputTimberFireSettings />;
  }

  return <SXInputConcreteFireSettings />;
};
